export const camelCaseToTitleCase = string => {
  if (!string) return string;

  return string
    .replace(/([A-Z])/g, " $1")
    .replace(
      /\w\S*/g,
      word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    )
    .trim();
};
